import { postUrl } from '../postUrl';


/**
 * Domains that will be checked to add the GMS Synxis token.
 *
 * * Note: Tc-theme Only
 */
const domainsThatAddSynxisToken = '(' + ['synxis.com'].join('|') + ')';

/**
 * Handler for Synxis post.
 * If is a Synxis link, and link has parameter &session be need to do a POST
 * for that href. not an usual GET.
 * @returns void
 * * Note: Tc-theme Only
 */
const handleClickForPost = function(url) {
  if (isSynxisWithToken(url)) {
    // is a POST
    postUrl(url, '_blank');
    return;
  }
  // is a GET (window.open)
  window.open(url, '_blank');
  return;
};

/**
 * Checks if URL is a Synxis Link and it also has the parameter session
 * @param {string} url
 * @returns Boolean
 * * Note: Tc-theme Only
 */
const isSynxisWithToken = function(url) {
  const urlObj = new URL(url);
  if (urlObj.hostname.match(domainsThatAddSynxisToken) === null) {
    return false;
  }
  if (!urlObj.searchParams.has('session')) {
    return false;
  }
  return true;
};

export {
  domainsThatAddSynxisToken,
  handleClickForPost,
}